<div class="business-state-stats w-full">
  <div
    class="grid grid-cols-1 gap-4 relative"
    [ngClass]="visibleBusinessCards.length > 1 ? 'md:grid-cols-2' : ''">
    @for (card of visibleBusinessCards; track card.key) {
      <app-cards
        [data]="businessData[card.key]"
        [cardHeading]="card.heading"
        [valueKey]="card.valueKey"
        [curveType]="'curveLinear'"
        [tableHeaders]="card.tableHeaders"
        [unit]="dateRange.unit || 'day'"
        class="w-full" [isLoading]="isLoading()" >
      </app-cards>
    }
  </div>
</div>
